var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.435364 9.93536C1.42441 12.6009 3.99022 14.5006 6.99997 14.5006C10.0097 14.5006 12.5755 12.6009 13.5646 9.93536L6.99997 9.32669L0.435364 9.93536Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 0.500458C3.99022 0.500458 1.42441 2.40008 0.435364 5.06569L6.99997 5.67436L13.5646 5.06566C12.5755 2.40008 10.0097 0.500458 6.99997 0.500458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.435395 5.06503C0.154027 5.82336 0 6.64356 0 7.4998C0 8.35605 0.154027 9.17625 0.435395 9.93457H13.5646C13.846 9.17625 14 8.35605 14 7.4998C14 6.64356 13.846 5.82336 13.5646 5.06503H0.435395Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.28ce5517c89003b290057e87433db14f.svg";
export { ForwardRef as ReactComponent };